<template>
    <div style="padding-top:-2px;margin-top:-2px;">
      <v-label ><b>{{label}}</b></v-label>
      <s-select-generic style=""
        
        :config="config"
        :disabled="disabled"
        :readonly="readonly" 
        :itemvalue="id"
        :clearable=clearable
        @add="addEvent()"
        :id="id"
        :value="value"
        @input="input($event)"
        :returnObject="returnObject"
      /></div>
  </template>
  
  <script>
  import _sGenericService from "./../../services/General/GenericService";
  
  export default {
    components: {  },
    props: {
      id: {
        type: String,
        default: "GenID",
      },
      value: null,
      label: {
        type: String,
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      noDefault: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      returnObject: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      valueRadio: null,
      selected: [],
  
      dialogAdd: false,
      item: 0,
      items: [],
      lastFetchedCmpID: null,
      config: {
        url: _sGenericService.getUrlSearchCampaignSe(),
        title: "",
        params: {
          defID: 0,
          dgrID: 0,
          requestID: 0,
        },
      },
    }),
  
    watch: {
  
    },
  methods: {
    input(item) {
      this.$emit("input", item);
      
      if (item) {
        // Only fetch if this is a different campaign than the last one fetched
        if (item !== this.lastFetchedCmpID) {
          this.lastFetchedCmpID = item;
          this.fetchCampaignDates(item);
        }
      } else {
        // Reset when cleared
        this.lastFetchedCmpID = null;
        this.$emit("datesLoaded", { CmpBeginDate: null, CmpEndDate: null });
      }
    },
    
    fetchCampaignDates(CmpID) {
      this.$http.post(
        this.$http.defaults.baseURL + '/generic/campaignDates',
        {},
        {
          params: {
            CmpID: CmpID,
            requestID: this.$fun.getUserID()
          }
        }
      ).then(response => {
        if (response.status === 200 && response.data) {
          this.$emit("datesLoaded", response.data);
        }
      }).catch(error => {
        this.$emit("datesLoaded", { CmpBeginDate: null, CmpEndDate: null });
      });
    },
    
    addEvent() {
      this.$emit("add");
    },
  },
    created() {
      this.config.title = this.label;
      this.config.params.requestID = this.$fun.getUserID();
  
     
    },
  };
  </script>
  